<script>
export default {
    name: 'oc-dynamic-structure',
    props: {
        /*
        {
            tag: 'text-input',
            text: null,
            children: [],
            // https://vuejs.org/v2/guide/render-function.html#The-Data-Object-In-Depth
            options: {
                // Same API as `v-bind:class`
                class: {
                    foo: true,
                    bar: false
                },
                // Same API as `v-bind:style`
                style: {
                    color: 'red',
                    fontSize: '14px'
                },
                // Normal HTML attributes
                attrs: {
                    id: 'foo'
                },
                // Component props
                props: {
                    myProp: 'bar'
                },
                // DOM properties
                domProps: {
                    innerHTML: 'baz'
                },
                // Event handlers are nested under `on`, though
                // modifiers such as in `v-on:keyup.enter` are not
                // supported. You'll have to manually check the
                // keyCode in the handler instead.
                on: {
                    click: this.clickHandler
                },
                // For components only. Allows you to listen to
                // native events, rather than events emitted from
                // the component using `vm.$emit`.
                nativeOn: {
                    click: this.nativeClickHandler
                },
                // Custom directives. Note that the `binding`'s
                // `oldValue` cannot be set, as Vue keeps track
                // of it for you.
                directives: [
                    {
                        name: 'my-custom-directive',
                        value: '2',
                        expression: '1 + 1',
                        arg: 'foo',
                        modifiers: {
                            bar: true
                        }
                    }
                ],
                // Scoped slots in the form of
                // { name: props => VNode | Array<VNode> }
                scopedSlots: {
                    default: props => createElement('span', props.text)
                },
                // The name of the slot, if this component is the
                // child of another component
                slot: 'name-of-slot',
                // Other special top-level properties
                key: 'myKey',
                ref: 'myRef'
            }
        }
        */
        schema: {
            type: Object,
            required: true
        },
    },
    render(createElement) {

        if( ! Object.keys(this.schema).length )
            return

        const renderNode = function(node, h) {
            let children = []

            if(node.text)
                children.push(node.text)

            if(node.children && node.children.length) {
                Object.keys(node.children).forEach( subNodeIndex => {
                    let subNode = node.children[subNodeIndex]

                    children.push(
                        typeOf(subNode) === 'string'
                            ? subNode
                            : renderNode(subNode, h)
                    )
                })
            }

            let options = node.options

            return h(node.tag, options, children)
        }

        return renderNode(this.schema, createElement)
    }
}
</script>
